import type { PortalKey } from '@/api/client';
import { PORTAL_COPY, pathForPortal } from '@/lib/portal';
import { BestyMark } from '@/components/BestyMark';
import { Card, ErrorNote } from '@/ui';

const ERROR_MESSAGES: Record<string, string> = {
  domain: 'That Google account is not allowed here. Sign in with your work account.',
  not_invited: 'That account has not been given access yet. Ask Besty to add you.',
  disabled: 'That account has been disabled. Contact Besty.',
  bad_state: 'Sign-in expired. Please try again.',
  verify_failed: 'Could not verify your Google sign-in. Please try again.',
  missing_code: 'Sign-in was interrupted. Please try again.',
  server: 'Something went wrong. Please try again.',
};

export function Login({ portal }: { portal: PortalKey }) {
  const copy = PORTAL_COPY[portal];
  const error = new URLSearchParams(window.location.search).get('error');

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-[380px]">
        <div className="mb-8 flex items-center gap-2.5">
          <BestyMark size={22} className="text-neutral-950" />
          <span className="text-[15px] font-medium text-neutral-950">Besty</span>
        </div>
        <Card className="p-8">
          <h1 className="font-serif text-[28px] leading-tight font-normal tracking-[-0.02em] text-neutral-950">
            {copy.name}
          </h1>
          <p className="mt-2 text-[14px] text-neutral-500">
            Rollout and performance across every {copy.accounts} location.
          </p>

          {error && (
            <div className="mt-5">
              <ErrorNote>{ERROR_MESSAGES[error] ?? 'Sign-in failed. Please try again.'}</ErrorNote>
            </div>
          )}

          <a
            href={`/auth/google?redirect=${encodeURIComponent(pathForPortal(portal))}`}
            className="mt-6 flex h-10 w-full items-center justify-center rounded-[10px] bg-[#121212] text-[14px] font-medium text-white transition-colors hover:bg-neutral-800"
          >
            Continue with Google
          </a>
          <p className="mt-4 text-[13px] text-neutral-500">{copy.loginHint}</p>
        </Card>
      </div>
    </div>
  );
}
